import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=bd8e4998&"
import script from "./FilesView.vue?vue&type=script&lang=ts&"
export * from "./FilesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports